export const packageDetailsTableColumns = {
  qty: {enabled: true, order: 1, permission: undefined},
  dimensions: {enabled: true, order: 2, permission: undefined},
  volume: {enabled: true, order: 3, permission: undefined},
  weight: {enabled: true, order: 4, permission: undefined},
  description: {enabled: true, order: 5, permission: undefined},
  barcode: {enabled: true, order: 6, permission: undefined},
  sku: {enabled: true, order: 7, permission: undefined},
  value: {enabled: true, order: 8, permission: undefined},
  labels: {enabled: true, order: 9, permission: undefined},
  pallets: {enabled: true, order: 10, permission: undefined},
  packsInItem: {enabled: false, order: 11, permission: undefined}
};
